// extracted by mini-css-extract-plugin
export default {"popupContent":"DeleteJourneyPopup_popupContent__iGdYc","greyRibbon":"DeleteJourneyPopup_greyRibbon__RKvEx","warningText":"DeleteJourneyPopup_warningText__uyDmn"};